// Lote V-9 — Web shop API client.
//
// Espello directo de mobile/src/api/shop.ts para a SPA. O backend é o
// mesmo (/api/v1/shop/*), só cambia o transport (apiClient web).

import type {
  HardwareOrder,
  HardwareSku,
  HardwareOrdersListResponse,
  ShopCheckoutRequest,
  ShopProductsResponse,
  StripeRedirectResponse,
} from '@leyrochain/shared';

import { apiClient } from './client';

export type { HardwareSku, HardwareOrder };
export type ShopProduct = ShopProductsResponse['products'][number];

export async function listShopProducts(): Promise<ShopProduct[]> {
  const { data } = await apiClient.get<ShopProductsResponse>('/api/v1/shop/products');
  return data.products;
}

export async function startShopCheckout(sku: HardwareSku, quantity = 1): Promise<string> {
  const body: ShopCheckoutRequest = { sku, quantity };
  const { data } = await apiClient.post<StripeRedirectResponse>(
    '/api/v1/shop/checkout-session',
    body,
  );
  return data.url;
}

export async function listMyHardwareOrders(): Promise<HardwareOrder[]> {
  const { data } = await apiClient.get<HardwareOrdersListResponse>('/api/v1/shop/orders');
  return data.orders;
}
